// Framework
import pop from './components';

// Components
import Bricks from './components/bricks';
import CallResponse from './components/call-response';
import Feature from './components/feature';
import Form from './components/form';
import Header from './components/header';
import HeroVideo from './components/hero-video';
import LazyVideo from './components/lazy-video';
import LocalVideo from './components/local-video';
import MediaCarousel from './components/media-carousel';
import Preloader from './components/preloader';
import Sidebar from './components/sidebar';
import Testimonials from './components/testimonials';
import Themer from './components/themer';
import Typer from './components/typer';
import VimeoVideo from './components/vimeo-video';

// Define map of component handles to component classes
const classMap = {
    'bricks': Bricks,
    'call-response': CallResponse,
    'feature': Feature,
    'form': Form,
    'header': Header,
    'hero-video': HeroVideo,
    'lazy-video': LazyVideo,
    'local-video': LocalVideo,
    'media-carousel': MediaCarousel,
    'preloader': Preloader,
    'sidebar': Sidebar,
    'testimonials': Testimonials,
    'themer': Themer,
    'typer': Typer,
    'vimeo-video': VimeoVideo,
};

// Define all actions/commands that components pub/sub
const actions = {
    // Action events
    lockScroll: 'lock-scroll',
    unlockScroll: 'unlock-scroll',
    showOverlay: 'show-overlay',
    hideOverlay: 'hide-overlay',
    openModal: 'open-modal',
    closeModal: 'close-modal',
    loadModal: 'load-modal',
};

// Event handler functions
function handleDOMConentLoaded() {
    function cb() {
        // Do anything after components are created.
    }

    pop({ classMap, actions, cb });

    // set a CSS variable equal to the scrollbar width
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
}

// Add event listeners
document.addEventListener('DOMContentLoaded', handleDOMConentLoaded);
AOS.init({
    duration: 1000,
    once: true
});
